import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-header',
  templateUrl: './form-header.component.html',
  styleUrls: ['./form-header.component.scss']
})
export class FormHeaderComponent implements OnInit {

  @Input() header: string = '';
  @Input() class: string = null;
  @Input() subHeader: string = 'form.required_note';

  constructor() { }

  ngOnInit(): void {
  }

}
